import 'ant-design-pro/dist/ant-design-pro.css';

import Exception from 'ant-design-pro/lib/Exception';
import React, { Component } from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { webPManager } from 'smartpi-core-h5';

import { Auth } from './screens/auth/Auth';
import { CheckIn } from './screens/checkIn/CheckIn';
import { Coupon } from './screens/coupon/Coupon';
import { Course } from './screens/course/Course';
import { UpgradeEnrollment } from './screens/enrollment/UpgradeEenrollment';
import { Group } from './screens/group/Group';
import { Home } from './screens/home/Home';
import { CrmLayout } from './screens/layouts/CrmLayout';
import { Logistics } from './screens/logistics/Logistics';
import { Marketing } from './screens/marketing/Marketing';
import { Order } from './screens/order/Order';
import { RedeemCode } from './screens/redeemCode/RedeemCode';
import { RedeemCodeTemplate } from './screens/redeemCode/RedeemCodeTemplate';
import { Redpack } from './screens/redpack/Redpack';
import { ReturnVisit } from './screens/returnVisit/ReturnVisit';
import { RolePermission } from './screens/rolePermission/RolePermission';
import { Statistic } from './screens/statistic/Statistic';
import { Stock } from './screens/stock/Stock';
import { Teacher } from './screens/teacher/Teacher';
import { Tool } from './screens/tools/Tool';
import { User } from './screens/user/User';
import { WorkOrder } from './screens/workOrder/WorkOrder';
import { authManager } from './services/auth';
import { noMaskingManager } from './services/noMasking';

interface State {}

type Props = RouteComponentProps<{}>;

class App extends Component<Props, State> {
  // TODO (greg): integrate sentry
  componentDidCatch(error: Error) {
    console.log('ERROR BOUNDARY', error);
  }
  componentDidMount() {
    this.addMaskingBackDoor();
  }

  // 添加数据脱敏后门，用户在页面点击 shift + R/r 就可以看到未脱敏的数据
  addMaskingBackDoor() {
    const KEY_CODES = ['ShiftLeft', 'KeyR'];
    let keyCodes: string[] = [];

    window.addEventListener('keydown', (e: KeyboardEvent) => {
      keyCodes.push(e.code);
    });

    window.addEventListener('keypress', (e: KeyboardEvent) => {
      const isContain = KEY_CODES.every(code => {
        return keyCodes.some(e => e === code);
      });
      if (isContain && keyCodes.length === KEY_CODES.length) {
        noMaskingManager.setNoMasking(true);
        window.location.reload();
      }
      keyCodes = [];
    });
  }
  render() {
    const { location } = this.props;
    const { pathname } = this.props.location;
    const token = authManager.getToken();
    return (
      <div>
        <Switch location={location}>
          <Route path="/auth" component={Auth} />
          {!token ? (
            <Redirect to={{ pathname: '/auth', state: { returnPath: this.props.location.pathname } }} {...this.props} />
          ) : (
            <CrmLayout pathname={pathname}>
              <Switch location={location}>
                <Route path="/user" component={User} {...this.props} />
                <Route path="/coupon" component={Coupon} {...this.props} />
                <Route path="/group" component={Group} {...this.props} />
                <Route path="/teacher" component={Teacher} {...this.props} />
                <Route path="/stock" component={Stock} {...this.props} />
                <Route path="/course" component={Course} {...this.props} />
                <Route path="/tools" component={Tool} {...this.props} />
                <Route path="/enrollment/upgrade" component={UpgradeEnrollment} {...this.props} />
                <Route path="/redeem-code" component={RedeemCode} {...this.props} />
                <Route path="/redeem-code-send" component={RedeemCode} {...this.props} />
                <Route path="/redeem-code-template" component={RedeemCodeTemplate} {...this.props} />
                <Route path="/check-in" component={CheckIn} {...this.props} />
                <Route path="/marketing" component={Marketing} {...this.props} />
                <Route path="/order" component={Order} {...this.props} />
                <Route path="/work-order" component={WorkOrder} {...this.props} />
                <Route path="/redpack" component={Redpack} {...this.props} />
                <Route path="/logistics" component={Logistics} {...this.props} />
                <Route path="/statistic" component={Statistic} />
                <Route path="/return-visit" component={ReturnVisit} />
                <Route path="/role-permission-role" component={RolePermission} {...this.props} />
                <Route path="/role-permission-permission" component={RolePermission} {...this.props} />
                <Route path="/role-permission-worker" component={RolePermission} {...this.props} />
                <Route path="/" component={Home} {...this.props} />
                <Route render={() => <Exception type="404" />} />
              </Switch>
            </CrmLayout>
          )}
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);

// tslint:disable-next-line:no-floating-promises
webPManager.init();



// WEBPACK FOOTER //
// ./src/App.tsx